import { render } from "./keyword.vue?vue&type=template&id=6bc5a58a&scoped=true&ts=true"
import script from "./keyword.vue?vue&type=script&lang=ts&config=true"
export * from "./keyword.vue?vue&type=script&lang=ts&config=true"

import "./keyword.vue?vue&type=style&index=0&id=6bc5a58a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc5a58a"]])

export default __exports__